import _extends from '@babel/runtime/helpers/esm/extends';
import React, { useState } from 'react';
import styled from 'styled-components';

function addDays(date, days) {
  var cur_date = typeof date === "object" ? date : new Date(date);
  var time = cur_date.getTime();
  time += days * 86400000; // 24 * 60 * 60 * 1000

  return new Date(time);
}
function getDatesOfWeek(week, year) {
  var simple = new Date(year || new Date().getFullYear(), 0, 1 + (week - 1) * 7);
  var dow = simple.getDay();
  var ISOweekStart = simple;
  if (dow <= 4) ISOweekStart.setDate(simple.getDate() - simple.getDay());else ISOweekStart.setDate(simple.getDate() + 7 - simple.getDay());
  return Array(7).fill(null).map(function (_, idx) {
    return addDays(ISOweekStart, idx);
  });
}
function getWeekDayOfCurrentYear(date) {
  if (date === void 0) {
    date = new Date();
  }

  var current_year = new Date().getFullYear();
  var start_date = new Date("1/1/" + current_year);
  var start_year_time = start_date.getTime();
  var weekday_start_date = start_date.getDay();
  var current_time = addDays(date, -(date.getDay() - weekday_start_date)).getTime();
  return Math.floor((current_time - start_year_time) / (7 * 24 * 60 * 60 * 1000)) + 1;
}
function getWeekDay(date) {
  var weekday = new Array(7);
  weekday[0] = "sun";
  weekday[1] = "mon";
  weekday[2] = "tue";
  weekday[3] = "wed";
  weekday[4] = "thu";
  weekday[5] = "fri";
  weekday[6] = "sat";
  return weekday[date.getDay()];
}
function getMonthString(date) {
  var monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
  return monthNames[date.getMonth()];
}

function WeekSelection (_ref) {
  var _ref$year = _ref.year,
      year = _ref$year === void 0 ? new Date().getFullYear() : _ref$year,
      _ref$onWeekSelected = _ref.onWeekSelected,
      onWeekSelected = _ref$onWeekSelected === void 0 ? function () {} : _ref$onWeekSelected,
      _ref$selectedWeek = _ref.selectedWeek,
      selectedWeek = _ref$selectedWeek === void 0 ? getWeekDayOfCurrentYear(new Date()) : _ref$selectedWeek;
  var totalWeek = getWeekDayOfCurrentYear(new Date(year + "-12-31"));
  var currentWeek = getWeekDayOfCurrentYear(new Date());

  var onWeekClicked = function onWeekClicked(week) {
    onWeekSelected(week);
  };

  return React.createElement(Wrapper, null, Array(totalWeek).fill(0).map(function (_, idx) {
    return React.createElement(Week, {
      key: idx,
      selected: selectedWeek === idx + 1,
      current: currentWeek === idx + 1,
      onClick: function onClick() {
        return onWeekClicked(idx + 1);
      }
    }, idx + 1);
  }));
}
var Wrapper = styled.div({
  display: ' grid',
  gridTemplateColumns: '1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr',
  gridGap: 5,
  padding: 10
});
var Week = styled.div({
  fontSize: 14,
  color: '#ddd',
  // width: "7%",
  padding: 9,
  margin: 1,
  borderRadius: 5,
  textAlign: 'center',
  ':hover': {
    cursor: 'pointer',
    background: 'rgba(255,255,255,.1)'
  }
}, function (_ref2) {
  var selected = _ref2.selected,
      current = _ref2.current;
  return _extends({}, current ? {
    color: $redorange,
    fontWeight: 800
  } : null, {}, selected ? {
    color: '#fff',
    background: 'rgba(255,255,255,.1)',
    fontWeight: 'bolder'
  } : null);
});

var currentWeek = getWeekDayOfCurrentYear();
function WeekDaysPicker (_ref) {
  var _ref$onDateChanged = _ref.onDateChanged,
      onDateChanged = _ref$onDateChanged === void 0 ? function () {} : _ref$onDateChanged,
      _ref$selectedDate = _ref.selectedDate,
      selectedDate = _ref$selectedDate === void 0 ? new Date() : _ref$selectedDate;

  var _useState = useState(selectedDate),
      selected = _useState[0],
      setSelected = _useState[1];

  var _useState2 = useState(currentWeek),
      week = _useState2[0],
      setWeek = _useState2[1];

  var _useState3 = useState(getDatesOfWeek(week)),
      dates = _useState3[0],
      setDates = _useState3[1];

  var _useState4 = useState(false),
      weekSelecting = _useState4[0],
      setWeekSelecting = _useState4[1];

  var _useState5 = useState(selectedDate.getDay()),
      seletedDay = _useState5[0],
      setSeletedDay = _useState5[1];

  var totalWeek = getWeekDayOfCurrentYear(new Date(selectedDate.getFullYear() + "-12-31"));
  var todayString = new Date().toDateString();
  var isToday = selected.toDateString() === todayString;

  var onDayClick = function onDayClick(date) {
    setSeletedDay(date.getDay());
    onDateChanged(date);
    setSelected(date);
  };

  var onWeekSelected = function onWeekSelected(week) {
    var newDates = getDatesOfWeek(week);
    setWeek(week);
    setDates(newDates);
    onDateChanged(newDates[seletedDay]);
    setSelected(newDates[seletedDay]);
  };

  var onBackToTodayClick = function onBackToTodayClick() {
    setWeek(currentWeek);
    setSelected(new Date());
    setWeek(getWeekDayOfCurrentYear());
    setSeletedDay(new Date().getDay());
    setWeekSelecting(false);
  };

  return React.createElement(Relative, null, React.createElement(BackToToday, {
    isToday: isToday,
    onClick: onBackToTodayClick
  }, "Back to Today"), React.createElement(Wrapper$1, {
    bottomRadius: !weekSelecting
  }, dates.map(function (date) {
    return React.createElement(Day, {
      key: date.getUTCDay(),
      selected: seletedDay === date.getDay(),
      onClick: function onClick() {
        onDayClick(date);
      },
      isToday: date.toDateString() === todayString
    }, React.createElement("div", {
      className: "weekDay"
    }, getWeekDay(date)), React.createElement(Month, null, getMonthString(date), " ", date.getDate()));
  }), React.createElement(Week$1, {
    onClick: function onClick() {
      return setWeekSelecting(!weekSelecting);
    }
  }, React.createElement("div", null, React.createElement("strong", null, week), "/", totalWeek), React.createElement(Year, null, new Date().getFullYear()))), weekSelecting && React.createElement(WeekSelectionWrapper, null, React.createElement(WeekSelection, {
    onWeekSelected: onWeekSelected,
    selectedWeek: week
  })));
}
var $dark = '#272727';
var $lightGray = '#EBEBEB';
var $redorange = '#DC5758';
var Wrapper$1 = styled.div({
  display: 'flex',
  background: $lightGray,
  borderRadius: 12,
  overflow: 'hidden',
  position: 'relative',
  zIndex: 100,
  '::select': 'disabled'
}, function (_ref2) {
  var bottomRadius = _ref2.bottomRadius;
  return !bottomRadius ? {
    borderBottomRightRadius: 0,
    borderBottomLeftRadius: 0
  } : false;
});
var Day = styled.div({
  flex: 1,
  fontSize: 14,
  textAlign: 'center',
  color: '#000',
  minWidth: 60,
  minHeight: 50,
  cursor: 'pointer',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexDirection: 'column',
  '.weekDay': {
    fontWeight: 600,
    lineHeight: 0.9
  },
  ':hover': {
    background: '#cecece'
  }
}, function (props) {
  return _extends({}, props.isToday ? {
    color: $redorange,
    fontWeight: 600,
    background: '#f3f3f3'
  } : null, {}, props.selected ? {
    background: $redorange,
    color: '#fff',
    ':hover': {
      background: '#c75152'
    }
  } : null);
});
var Month = styled.div({
  fontSize: 12,
  opacity: 0.6
});
var Week$1 = styled.div({
  background: $dark,
  minWidth: 80,
  fontSize: 14,
  color: '#fff',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  cursor: 'pointer'
});
var Relative = styled.div({
  position: 'relative'
});
var WeekSelectionWrapper = styled.div({
  background: $dark,
  borderBottomLeftRadius: 12,
  borderBottomRightRadius: 12,
  position: 'absolute',
  top: '100%',
  width: '100%',
  zIndex: 99
});
var Year = styled.div({
  fontSize: 12,
  color: 'rgba(255, 255, 255, 0.5)'
});
var BackToToday = styled.div({
  background: $dark,
  borderTopLeftRadius: 15,
  borderTopRightRadius: 15,
  color: '#bbb',
  fontSize: 11,
  position: 'absolute',
  bottom: '85%',
  padding: '5px 13px 6px',
  fontWeight: 700,
  cursor: 'pointer',
  transition: 'all .2s',
  left: 'calc(50% - 30px)',
  ':hover': {
    bottom: '100%',
    color: '#eee'
  }
}, function (_ref3) {
  var isToday = _ref3.isToday;
  return isToday ? {
    bottom: 0
  } : null;
});

export default WeekDaysPicker;
export { addDays, getDatesOfWeek, getMonthString, getWeekDay, getWeekDayOfCurrentYear };



//////////////////
// WEBPACK FOOTER
// ./node_modules/react-weekdays-picker/dist/react-weekdays-picker.esm.js
// module id = 79
// module chunks = 0